import {LOADING} from '../actions/types'

const initalState = {loading: false}
const loadingReducer = (state = initalState, action) => {
  switch (action.type) {
  
    
      


      case LOADING.FETCH:
      


      return {loading: true }

       case LOADING.SUCCESS:
       case LOADING.FAIL:
       case LOADING.FINISH:


      return {loading:  false}

        
    default:
      return state;
  }
};

export default loadingReducer;